import { useFlag } from '@calendly/feature-check-react'
import { Loader } from '@calendly/ui/components/loader'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { RemoteContactsSearchHandler } from 'features/crm'
import { useRightRail } from 'features/right_rail'
import { useTrack } from 'hooks/analytics_events'

import { AvatarDropdown } from './avatar_dropdown'
import { FullStoryExclude } from '../../../../../../../shared/fullstory_privacy'

export const CrmExternalInvitee = ({ cancelled,
  isHost,
  invitee,
  toggle }) => {
  const [contact, setContact] = useState()
  const [displayName, setDisplayName] = useState()
  const history = useHistory()
  const isCRMContactCardFlagEnabled = useFlag('crm_contactcard_feature')
  const isCRMContactDetailFlagEnabled = useFlag('crm_contactdetails_feature')
  const isCRMContactDetailsPageEnabled = isCRMContactCardFlagEnabled && isCRMContactDetailFlagEnabled
  const track = useTrack()
  const sendAnalytics = () => {
    track({
      name: 'Contact Interaction',
      properties: {
        action: 'contact_details_view',
        location: 'meetings_page_right_rail',
        contact_uuid: contact?.id || null,
      }
    })
  }

  const handleResults = (results) => {
    const result = results?.[0]
    setContact(result)
    setDisplayName(result?.name || invitee.name || invitee.email)
  }

  const isContact = Boolean(contact)
  const canShowMoreInfo = isContact || (Boolean(invitee.name && invitee.email))

  const { openOrReplace, close } = useRightRail()

  const handleClick = () => {
    if (!canShowMoreInfo || isHost) return
    if (isHost) return
    if (contact) {
      if (isCRMContactDetailsPageEnabled) {
        close()
        // open contacts page
        history.push(`/app/contacts/${contact.id}`)
        sendAnalytics()
      } else {
        // open right rail
        openOrReplace('remote_contacts', { contactId: contact.id })
      }
    } else {
      toggle()
    }
  }

  return (
    <FullStoryExclude>
      <RemoteContactsSearchHandler
        query={invitee.email}
        onResults={handleResults}
      />
      {!displayName && <Loader data-testid="contact-loader" size="small" />}
      {displayName && (
      <AvatarDropdown
        displayName={displayName}
        cancelled={cancelled}
        isHost={isHost}
        isContact={isContact}
        canShowMoreInfo={canShowMoreInfo}
        handleClick={handleClick}
        contact={contact}
      />
      )}
    </FullStoryExclude>
  )
}
